import {
  H5,
  H6,
  Text,
  Button,
  Box,
  defaultTheme,
  L88
} from "@adfenix/alexandria";
import styled from "styled-components";
import { TemplateActions } from "./TemplateActions";
import { Fragment, useState } from "react";
import { PreviewTemplateModal } from "../modal/preview/TemplatePreviewModal";
import { TemplateService } from "@adfenix/types";
import { channelIcons } from "utils/channelIcons";
import { isFacebookTemplate, subjectTypeToPascalCase } from "utils/types";

interface Props {
  templates: (
    | TemplateService.FacebookContentTemplateModel
    | TemplateService.TwitterContentTemplateModel
    | TemplateService.InstagramContentTemplateModel
  )[];
  channel: TemplateService.ChannelType;
  subjectType: TemplateService.SubjectType;
}

const StyledH5 = styled(H5)`
  margin-left: 18px;
`;

export const StyledTemplateAction = styled(Button)`
  margin-left: 8px;
`;

const StyledIcon = styled.i`
  margin-left: 18px;
`;

const GridBox = styled(Box)`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
  column-gap: 24px;
`;

export const TemplateList = ({ templates, channel, subjectType }: Props) => {
  const [previewTemplateId, setPreviewTemplateId] = useState<string | null>(
    null
  );

  return (
    <>
      <PreviewTemplateModal
        parentSelector={`#templates-for-subject-${subjectType}`}
        templateId={previewTemplateId}
        channel={channel}
        onClose={() => setPreviewTemplateId(null)}
        type="ad"
        subjectType={subjectTypeToPascalCase(subjectType)}
      />
      {templates.map(model => {
        return (
          <Fragment key={model.id}>
            <Box
              pY="m"
              style={{
                borderTop: `1px solid ${L88(defaultTheme.colors.grey)}`
              }}
            >
              <Box
                display="flex"
                flexDirection="row"
                alignItems="center"
                pX="m"
              >
                <Text size="l">{model.name}</Text>
                <StyledIcon className={`uil uil-${channelIcons[channel]}`} />

                {model.default ? (
                  <StyledH5 color="primary">Default to channel</StyledH5>
                ) : null}

                <Box display="flex" style={{ marginLeft: "auto" }}>
                  <TemplateActions
                    template={model}
                    channel={channel}
                    onPreview={setPreviewTemplateId}
                  />
                </Box>
              </Box>
            </Box>
            <GridBox pX="m" pY="m">
              <Box>
                <H6>Ad message</H6>
                <Text size="m">{model.message}</Text>
              </Box>

              {isFacebookTemplate(model) ? (
                <>
                  <Box>
                    <H6>Ad headline</H6>
                    <Text size="m">{model.headline}</Text>
                  </Box>
                  <Box>
                    <H6>Ad description</H6>
                    <Text size="m">{model.description}</Text>
                  </Box>
                </>
              ) : null}
            </GridBox>
          </Fragment>
        );
      })}
    </>
  );
};
